import { s, type SpacingToken } from '@/theme/tokens';

export const detailPageSectionGapToken: SpacingToken = '2xl';
export const detailPageSectionGap = s(detailPageSectionGapToken);
